import { useMemo } from 'react'
import { collection, query, where } from 'firebase/firestore'
import type { DocumentData, Query } from 'firebase/firestore'
import { db } from '../lib/firebase'
import { useFirestoreCollection } from './useFirestore'
import { useAuth } from './useAuth'

// Live `status == 'pending'` docs of an admin triage collection, for the nav
// chrome badge. Listening to just the pending slice (rather than the whole
// collection the admin list pages show) keeps every admin page load from
// re-reading the full triage history. Non-admins run no query.
export function useAdminPendingDocs<T extends DocumentData>(collectionName: string): T[] {
  const { isAdmin } = useAuth()
  const pendingQuery = useMemo(
    () =>
      isAdmin
        ? (query(collection(db, collectionName), where('status', '==', 'pending')) as Query<T>)
        : null,
    [isAdmin, collectionName],
  )
  return useFirestoreCollection<T>(pendingQuery).data
}
